/*! correcting-interval 2.0.0 | Copyright 2014 Andrew Duthie | MIT License */
/* jshint evil: true */
let numIntervals = 0;
const intervals = {};

const setCorrectingInterval = function setCorrectingInterval(func, delay) {
  numIntervals += 1;
  const id = numIntervals;
  let planned = Date.now() + delay;

  function tick() {
    func();

    // Only re-register if clearCorrectingInterval was not called during function
    if (intervals[id]) {
      planned += delay;
      intervals[id] = setTimeout(tick, planned - Date.now());
    }
  }

  intervals[id] = setTimeout(tick, delay);
  return id;
};

const clearCorrectingInterval = function clearCorrectingInterval(id) {
  clearTimeout(intervals[id]);
  delete intervals[id];
};

export { setCorrectingInterval, clearCorrectingInterval };
